import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from '../../i18n';
import { getLatestPosts, getCategoryName } from '../../data/blogPosts';
import './BlogSection.css';

const BlogSection = () => {
  const { t, language } = useTranslation();
  const latestPosts = getLatestPosts(4);

  const localeMap = {
    pt: 'pt-BR',
    en: 'en-US',
    es: 'es-ES'
  };

  return (
    <motion.section
      className="blog-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1.3 }}
    >
      <div className="blog-section-header">
        <h2>{t('blog.latestNews')}</h2>
        <Link to="/blog" className="view-all-link">
          {t('common.viewAll')}
          <span className="arrow">→</span>
        </Link>
      </div>

      <div className="blog-grid">
        {latestPosts.map((post, index) => (
          <motion.article
            key={post.id}
            className="blog-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.4 + index * 0.1 }}
            whileHover={{
              scale: 1.02,
              transition: { duration: 0.2 }
            }}
          >
            <Link to={`/blog/${post.slug}`} className="blog-card-link">
              <div className="blog-card-image">
                <img src={post.image} alt={post.title} loading="lazy" />
                <span className="blog-card-category">{getCategoryName(post.category)}</span>
              </div>
              <div className="blog-card-content">
                <h3 className="blog-card-title">{post.title}</h3>
                <p className="blog-card-description">{post.description}</p>
                <div className="blog-card-meta">
                  <span className="blog-card-date">{new Date(post.date).toLocaleDateString(localeMap[language] || 'pt-BR')}</span>
                  <span className="blog-card-read-time">{post.readTime}</span>
                </div>
              </div>
            </Link>
          </motion.article>
        ))}
      </div>
    </motion.section>
  );
};

export default BlogSection;
